'use client';
import React, { useEffect, useRef, useState } from 'react';

interface Partner {
  id: number;
  src: string;
  alt: string;
}

const partners: Partner[] = [
{ id: 1, src: 'https://innobox.cl/wp-content/uploads/2025/05/1.png', alt: 'Partner tecnológico de Innobox' },
{ id: 2, src: "https://img.rocket.new/generatedImages/rocket_gen_img_1b43c8e63-1765286150777.png", alt: 'Partner de soluciones digitales' },
{ id: 3, src: 'https://innobox.cl/wp-content/uploads/2025/05/5-1.png', alt: 'Partner de tecnología Innobox' },
{ id: 4, src: "https://img.rocket.new/generatedImages/rocket_gen_img_155d41809-1780668731802.png", alt: 'Partner de infraestructura tecnológica' },
{ id: 5, src: "https://img.rocket.new/generatedImages/rocket_gen_img_120c2008a-1782338725765.png", alt: 'Partner de software y servicios digitales' },
{ id: 6, src: 'https://innobox.cl/wp-content/uploads/2025/05/lenovo2-1.png', alt: 'Lenovo - fabricante de equipamiento tecnológico partner de Innobox' }];


const PartnersSection: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  // Duplicate for seamless marquee
  const allPartners = [...partners, ...partners];

  return (
    <section
      id="partners"
      ref={sectionRef}
      className="relative overflow-hidden"
      style={{ backgroundColor: '#202427', paddingTop: '80px', paddingBottom: '80px' }}>
      
      {/* Grid lines */}
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute top-0 bottom-0 left-[25%] w-px bg-white/5" />
        <div className="absolute top-0 bottom-0 left-[50%] w-px bg-white/5" />
        <div className="absolute top-0 bottom-0 left-[75%] w-px bg-white/5" />
        <div className="absolute left-0 right-0 top-0 h-px bg-white/6" />
        <div className="absolute left-0 right-0 bottom-0 h-px bg-white/6" />
      </div>

      <div className="max-w-[1280px] mx-auto px-6 relative z-10">
        {/* Header */}
        <div
          className={`flex items-center gap-6 mb-12 transition-all duration-700 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`
          }>
          <div className="w-6 h-px bg-[#abd233] flex-shrink-0" />
          <span style={{ fontSize: '12px', letterSpacing: '0.1em', color: '#abd233', textTransform: 'uppercase' }}>
            Partners Innobox
          </span>
          <div className="flex-1 h-px bg-white/6" />
        </div>
      </div>

      {/* Marquee */}
      <div
        className={`relative overflow-hidden transition-all duration-700 delay-200 ${
        isVisible ? 'opacity-100' : 'opacity-0'}`
        }>
        {/* Fade edges */}
        <div
          className="absolute left-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to right, #202427, transparent)' }} />
        
        <div
          className="absolute right-0 top-0 bottom-0 w-32 z-10 pointer-events-none"
          style={{ background: 'linear-gradient(to left, #202427, transparent)' }} />
        

        <div className="cipher-marquee-track py-4">
          {allPartners.map((partner, index) =>
          <div
            key={index}
            className="flex items-center justify-center flex-shrink-0 px-8 transition-all duration-300 hover:opacity-80"
            style={{ minWidth: '160px' }}>
              <img
              src={partner.src}
              alt={partner.alt}
              className="h-8 w-auto object-contain"
              style={{ filter: 'brightness(0) invert(1)', opacity: 0.35 }} />
            
            </div>
          )}
        </div>
      </div>

      {/* Bottom text */}
      <div className="max-w-[1280px] mx-auto px-6 relative z-10">
        <div
          className={`mt-12 text-center transition-all duration-700 delay-300 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`
          }>
          <p className="text-white/30" style={{ fontSize: '13px', letterSpacing: '0.05em' }}>
            Con el apoyo de grandes marcas, impulsamos soluciones complejas que marcan un antes y un después en cada organización.
          </p>
        </div>
      </div>
    </section>);

};

export default PartnersSection;